import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ServiceCRUD } from '../../../shared/crud/ServiceCRUD';
import { environment } from '../../../../environments/environment';

@Injectable()
export class StatusOperacaoFiltroService extends ServiceCRUD {
  private baseUrlService: string;
  private url: string;

  constructor(public httpClient: HttpClient, router: Router) {
    super(httpClient, router);
    this.baseUrlService = environment.URL_API;
  }

  protected getURL(): string {
    return this.url;
  }

  private definirURLFiltroDealers() {
    this.url = `${this.baseUrlService}/filtro/dealer`;
  }

  public getFiltroDealers(): any {
    this.definirURLFiltroDealers();
    return this.get([]);
  }

}
